import useText from "constants/text";
import { Advantage } from "generated/graphql";
import { BadgeIcon } from "icons";
import React from "react";
import { Carousel } from "react-responsive-carousel";
import { Button } from "ui/Button";
import { formatAmount } from "utils/index";
import {
  StyledAdvantageContainer,
  StyledAdvantageTitle,
  StyledAdvantagePrice,
  StyledAdvantageInfos,
  useFidelyStyles,
} from "../style";
import { formatAddress } from "../utils";
import DotIndicator from "./carousel/DotIndicator";

interface AdvantageProps {
  onClick: (advantage: Advantage) => void;
  advantage: Advantage;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  onCardClick?: (advantage: Advantage) => void;
  setIsDetailPage?: React.Dispatch<React.SetStateAction<boolean>>;
}

function AdvantageItem({ onClick, advantage, setOpen, onCardClick, setIsDetailPage }: AdvantageProps) {
  const styles = useFidelyStyles();
  const { text } = useText();

  const handleOpenUseModal = (e: any) => {
    setOpen(true);
    setIsDetailPage(false);
    onClick(advantage);
    e.stopPropagation();
  };

  const renderIndicator = (_: (e: React.MouseEvent | React.KeyboardEvent) => void, isSelected: boolean) => {
    return <DotIndicator width="10px" height="10px" isSelected={isSelected} />;
  };
  return (
    <StyledAdvantageContainer
      quantity={advantage?.remainQuantity}
      isValidRequest={advantage?.remainQuantity <= 0}
      onClick={() => onCardClick(advantage)}
    >
      <div className={styles.brandImage}>
        <BadgeIcon />
      </div>
      <StyledAdvantageTitle className={styles.title}>{advantage?.service?.label}</StyledAdvantageTitle>
      <StyledAdvantagePrice>{`${advantage?.maxAmount}%`} </StyledAdvantagePrice>
      <Carousel
        autoPlay
        className={styles.carouselInfos}
        showStatus={false}
        showArrows={false}
        renderIndicator={renderIndicator}
        infiniteLoop
      >
        <StyledAdvantageInfos>{`*${text.fidelity_program.only_applicable_in} ${formatAddress(
          advantage?.address
        )}`}</StyledAdvantageInfos>
        <StyledAdvantageInfos>{`*${text.fidelity_program.usable_for} ${advantage?.remainQuantity} ${text.all.times}`}</StyledAdvantageInfos>
      </Carousel>
      <Button
        className={styles.useNowButton}
        disabled={advantage?.quantity === 0 || !advantage?.isValidRequest}
        onClick={handleOpenUseModal}
      >
        {text.all.use_now}
      </Button>
    </StyledAdvantageContainer>
  );
}

export default AdvantageItem;
